import React, { useEffect, useState } from "react";

const Terminal = ({ isTaskCompleted }) => {
  const [processes, setProcesses] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      let isRogue = Math.random() > 0.3; //70% chance to be a rogue process
      if (isTaskCompleted) {
        isRogue = 0;
      }
      const newProcess = {
        id: Math.random().toString(36).substr(2, 9),
        name: isRogue ? "malware" : "authorized",
        pid: Math.floor(Math.random() * 10000),
        mem: isTaskCompleted
          ? (Math.random() * 10).toFixed(1)
          : (Math.random() * 40).toFixed(1) + "%",
        status: "Running",
      };
      setProcesses((prevProcesses) => {
        if (prevProcesses.length >= 10) {
          return [...prevProcesses.slice(1), newProcess];
        }
        return [...prevProcesses, newProcess];
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isTaskCompleted]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="z-10 relative w-full h-full flex flex-col justify-center px-0 md:px-8">
      <h1 className="text-lg sm:text-xl md:text-2xl text-center mb-2">
        {isTaskCompleted
          ? "Malware removed from rogue device"
          : "Rogue device running malware"}
      </h1>
      <div className="relative px-4 sm:px-8 md:px-16 py-4 sm:py-8 flex justify-center h-full">
        <div className="-z-10 absolute top-0 left-0 w-full h-full">
          <img
            src={require(`../../static/images/visuals/computerScreen.png`)}
            alt="Computer Screen"
            className="w-full h-full rounded-lg"
          />
        </div>
        <div className="bg-black text-green-500 font-mono p-2 w-full sm:w-[90%] md:w-[90%] h-[70%] rounded-md overflow-y-auto text-xs sm:text-sm">
          <div className="mb-1">
            top - 18:44:27 up 1 day, 2:31, 3 users, load average: 0.00, 0.01,
            0.05
          </div>
          <div className="mb-1">
            Tasks: 128 total, 1 running, 127 sleeping, 0 stopped, 0 zombie
          </div>
          <div className="mb-1">
            %Cpu(s): {isTaskCompleted ? "15%" : "100%"}
          </div>
          <div className="mb-1">
            KiB Mem :{" "}
            {!isTaskCompleted
              ? "2048576 total, 0 free, 100% used"
              : "2048576 total, 80% free, 20% used"}
          </div>

          {/* Table Headers */}
          <div className="mb-1 grid grid-cols-5 md:grid-cols-8 gap-1">
            <div>PID</div>
            <div className="hidden md:block">USER</div>
            <div>MEM</div>
            <div className="hidden md:block">STATUS</div>
            <div>%CPU</div>
            <div>%MEM</div>
            <div className="hidden md:block">TIME+</div>
            <div>COMMAND</div>
          </div>

          {/* Table Rows */}
          <div className="overflow-x-auto">
            {processes.map((process) => (
              <div
                key={process.id}
                className="grid grid-cols-5 md:grid-cols-8 gap-1"
              >
                <span>{process.pid}</span>
                <span className="hidden md:block">user</span>
                <span>
                  {isTaskCompleted
                    ? (Math.random() * 100).toFixed(0)
                    : (Math.random() * 1000).toFixed(0)}
                  m
                </span>
                <span className="hidden md:block">{process.status}</span>
                <span>
                  {isTaskCompleted
                    ? (Math.random() * 10).toFixed(1)
                    : (Math.random() * 40).toFixed(1)}
                </span>
                <span>{process.mem}</span>
                <span className="hidden md:block">
                  0:00.{Math.floor(Math.random() * 100)}
                </span>
                <span>{process.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terminal;
